<template>
    <div class="zebra-crossing-detail">
        <!--  表单明细 -->
        <el-form :model="detail">
            <div class="zebra-item">

                <!-- 资产类型 采购时间 -->
                <el-row>
                    <el-col :span="12" >
                        <el-form-item label="资产类型：">{{ detail.assetType | tableVal(cmdbAssetType)}}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="采购时间：">{{ detail.purchaseTime }}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 资产成本 到货时间 -->
                <el-row>
                    <el-col :span="12" >
                        <el-form-item label="资产成本：">{{ detail.assetCost }}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="到货时间：">{{ detail.arrivalTime }}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 环境类型 借用到期日 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="环境类型：">{{ detail.envType | tableVal(envType) }}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="借用到期日：">{{ detail.borrowEndTime }}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 型号 保修开始时间 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="型号：">{{ detail.model }}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="保修开始时间：">{{ detail.warrantyStartTime }}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 序列号 保修结束时间 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="序列号：">{{ detail.serialNum }}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="保修结束时间：">{{ detail.warrantyEndTime }}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 品牌 报废日期 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="品牌：">{{ detail.brand | tableVal(brand)}}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="报废日期：">{{ detail.retireTime }}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 供应商 所在位置 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="供应商：">{{ detail.supplier | tableVal(supplier)}}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="所在位置：">{{ detail.place | tableVal(location) }}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 物理地址 影响服务 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="物理地址：">{{ detail.physicalAddress }}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="影响服务：">
                            <span v-for='(item, index) of detail.toService' :key='item.serialNumber'>
                                {{item.title}}
                                {{ detail.toService.length - 1 === index ?'': "," }}
                            </span>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 厂商联系人 文件 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="厂商联系人：">
                            <span v-for='(item, index) of detail.toUser' :key='item.userid'>
                                {{item.name}}
                                {{ detail.toUser.length - 1 === index ?'': "," }}
                            </span>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="文件：">
                            <div  v-for='(item, index) of detail.toDocument' :key='index'>
                                <!-- {{item}} -->
                                <a style="float:left" :href="item.url" rel="external nofollow" download="模板">
                                    <el-button type="text">{{item.title}}</el-button>
                                    {{ detail.toDocument.length - 1 === index ?'': ", " }}
                                </a>
                                <span class="preview" @click="previewEvent(item)">预览</span>
                            </div>

                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 描述 -->
                <el-row>
                        <el-col :span="24">
                        <el-form-item label="描述：">
                            {{detail.description}}
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 附件 -->
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="附件：">
                            <div v-for='(item, index) of detail.attachment' :key='index'>

                                <a style="float:left"  :href="item.url" rel="external nofollow" download="模板">
                                    <el-button type="text">{{item.name}}</el-button>
                                    {{ detail.attachment.length - 1 === index ?'': "," }}
                                </a>
                                <span class="preview" @click="previewEvent(item)">预览</span>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>
    </div>
</template>

<script>
export default {

    props: {
        detail: Object,
    },

    computed:{
        // 字典
        dictionary() {
            return this.$store.state.dictionary;
        },
        //资产类型
        cmdbAssetType() {
            return this.dictionary.cmdb_asset_type;
        },
        //环境类型
        envType() {
            return this.dictionary.env_type;
        },
        // 品牌
        brand() {
            return this.dictionary.brand;
        },
        // 供应商
        supplier() {
            return this.dictionary.supplier;
        },
        // 所在位置
        location() {
            return this.dictionary.location;
        },
    },
    methods: {
        previewEvent(row){
            this.$router.push({
                name:'Preview',
                path:'/preview',
                query: {
                    file:row
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped rel="stylesheet/scss">
.zebra-crossing-detail .zebra-item .el-form-item__content{
    flex:none !important;
}
.preview{
    color:blue;
    cursor: pointer;
    margin-left: 10px;
}
</style>
